import * as React from 'react';
import { getYearRangeArray } from '../../helpers/calendar/calendar';
import './CalendarMonthYearSelector.scss';

interface Props {
  onPreviousMonthClick: () => void;
  onNextMonthClick: () => void;
  onMonthYearChange: (month: number, year: number) => void;
  activeMonthIndex: number;
  activeYearIndex: number;
}

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export function CalendarMonthYearSelector(props: Props) {
  const { onPreviousMonthClick, onNextMonthClick, onMonthYearChange, activeMonthIndex, activeYearIndex } = props;
  const years = getYearRangeArray();
  const activeYear = years[activeYearIndex];
  const [month, setMonth] = React.useState(activeMonthIndex);
  const [year, setYear] = React.useState(activeYear);

  React.useEffect(() => {
    setMonth(activeMonthIndex);
    setYear(activeYear);
  }, [activeMonthIndex, activeYear]);

  const now = new Date();
  const isCurrentMonth = activeMonthIndex === now.getMonth() && activeYear === now.getFullYear();
  const isJumpDisabled = month === activeMonthIndex && year === activeYear;

  return (
    <div className="cal-monthhd">
      <div className="cal-monthhd__current" aria-live="polite">
        <span className="cal-monthhd__eyebrow">Showing</span>
        <span className="cal-monthhd__title">
          {MONTH_NAMES[activeMonthIndex]} {activeYear}
        </span>
      </div>
      <div className="cal-monthJump" aria-label="Jump to month">
        <select aria-label="Month" value={month} onChange={event => setMonth(Number(event.target.value))}>
          {MONTH_NAMES.map((name, index) => (
            <option key={name} value={index}>
              {name}
            </option>
          ))}
        </select>
        <select aria-label="Year" value={year} onChange={event => setYear(Number(event.target.value))}>
          {years.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="cal-monthJump__go"
          disabled={isJumpDisabled}
          onClick={() => onMonthYearChange(month, year)}
        >
          Go
        </button>
        {!isCurrentMonth && (
          <button
            type="button"
            className="cal-monthJump__today"
            onClick={() => onMonthYearChange(now.getMonth(), now.getFullYear())}
          >
            Today
          </button>
        )}
      </div>
      <span className="cal-monthhd__spacer" />
      <div className="cal-monthhd__paging" aria-label="Browse months">
        <button className="cal-nav" type="button" onClick={onPreviousMonthClick} aria-label="Previous month">
          ‹
        </button>
        <button className="cal-nav" type="button" onClick={onNextMonthClick} aria-label="Next month">
          ›
        </button>
      </div>
    </div>
  );
}
